import _actions_agreements_remove from './_actions/agreements/remove.js'
import _actions_agreements_edit from './_actions/agreements/edit.js'
import _actions_agreements_add from './_actions/agreements/add.js'
import _actions_save from './_actions/save.js'
import _actions_remove from './_actions/remove.js'
import _actions_data from './_actions/data.js'
import _actions_change from './_actions/change.js'
import _actions_add from './_actions/add.js'
import _getters_sumMax from './_getters/sumMax.js'
import _getters_paymentType from './_getters/paymentType.js'
import _getters_paymentOperation from './_getters/paymentOperation.js'
import _getters_paymentAccount from './_getters/paymentAccount.js'
import _getters_form from './_getters/form.js'
import _getters_data from './_getters/data.js'
import _getters_currency from './_getters/currency.js'
import _getters_cash from './_getters/cash.js'
import _mutations_set from './_mutations/set.js'
import _mutations_remove_agreement from './_mutations/remove_agreement.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_data from './_mutations/data.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        data: _mutations_data,
        loading: _mutations_loading,
        remove_agreement: _mutations_remove_agreement,
        set: _mutations_set,
    },
    getters:{
        cash: _getters_cash,
        currency: _getters_currency,
        data: _getters_data,
        form: _getters_form,
        paymentAccount: _getters_paymentAccount,
        paymentOperation: _getters_paymentOperation,
        paymentType: _getters_paymentType,
        sumMax: _getters_sumMax,
    },
    actions:{
        add: _actions_add,
        change: _actions_change,
        data: _actions_data,
        remove: _actions_remove,
        save: _actions_save,
        agreements_add: _actions_agreements_add,
        agreements_edit: _actions_agreements_edit,
        agreements_remove: _actions_agreements_remove,
    },
}